import FormClient from "./FormClient";

export default function OrganizationFormPage() {
    return <FormClient />;
}

